// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"23d522c6","455":"614387d1"}[chunkId] + ".chunk.js";
};